import { jsx, jsxs } from "react/jsx-runtime";
import { ListItemButton, Paper, Typography } from "@mui/material";
import { useMultiSelectState } from "../hooks/useMultiSelectState.js";
import { useTexts } from "../hooks/useTexts.js";
import { getVerticalPaddingByDensity } from "../utils/getVerticalPaddingByDensity.js";
function getMode(searchValue, visibleOptions, selectableOptions, selectedOptions) {
  if (searchValue !== "" && visibleOptions.length === 0) return "clear-search";
  if (selectableOptions.length === 0 && selectedOptions.length !== 0) return "clear-selected";
  return "select-unselected";
}
function getLabel(mode, selectedOptions, selectableOptions, texts) {
  switch (mode) {
    case "clear-search":
      return texts.clearSearch;
    case "clear-selected":
      return texts.clearAll(selectedOptions.length);
    case "select-unselected":
      return texts.selectAll(selectableOptions.length);
  }
}
function preventDefault(e) {
  e.preventDefault();
}
function MultiSelectPaperComponent(props) {
  const { children, ...otherPaperProps } = props;
  const texts = useTexts();
  const {
    props: { density = "normal", disableFooterDefaultActions },
    state: { selectableOptions, selectedOptions, visibleOptions },
    actions: { clearSelected, selectUnselected },
    searchState: [searchValue, setSearchValue]
  } = useMultiSelectState();
  const verticalPadding = getVerticalPaddingByDensity(density);
  const horizontalPadding = 1.5;
  const mode = getMode(searchValue, visibleOptions, selectableOptions, selectedOptions);
  const label = getLabel(mode, selectedOptions, selectableOptions, texts);
  const onClick = (e) => {
    e.preventDefault();
    switch (mode) {
      case "clear-search":
        setSearchValue("");
        break;
      case "clear-selected":
        clearSelected();
        break;
      case "select-unselected":
        selectUnselected();
        break;
    }
  };
  return /* @__PURE__ */ jsxs(Paper, { ...otherPaperProps, children: [
    children,
    !disableFooterDefaultActions && /* @__PURE__ */ jsx(
      ListItemButton,
      {
        onClick,
        onMouseDown: preventDefault,
        "data-testid": "multiselect-toggle-selection-button",
        children: /* @__PURE__ */ jsx(Typography, { variant: "button", color: "primary", paddingX: horizontalPadding, paddingY: verticalPadding, children: label })
      }
    )
  ] });
}
export {
  MultiSelectPaperComponent
};
//# sourceMappingURL=MultiSelectPaperComponent.js.map
